import { render, staticRenderFns } from "./PhoneBroadcastModal.vue?vue&type=template&id=d37c84ce&scoped=true"
import script from "./PhoneBroadcastModal.vue?vue&type=script&lang=js"
export * from "./PhoneBroadcastModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37c84ce",
  null
  
)

export default component.exports